module.exports = __webpack_public_path__ + "img/boy_010028.40c6ac84.png";